import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgLoodgieter = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#85BDED"
      d="M19 19h-6a5 5 0 0 0-5-5V8a11 11 0 0 1 11 11"
    />
    <path
      fill="#85BDED"
      d="M23 32a10 10 0 0 1-10-10h6a4 4 0 1 0 8 0v-7h6v7a10 10 0 0 1-10 10"
    />
    <path
      fill="#0061CD"
      d="M5.33 27.42c0-1.48 2.67-5.34 2.67-5.34s2.67 3.86 2.67 5.34a2.67 2.67 0 0 1-5.34 0M9.37 7H6.63a.63.63 0 0 0-.63.63v6.74c0 .348.282.63.63.63h2.74a.63.63 0 0 0 .63-.63V7.63A.63.63 0 0 0 9.37 7M19.37 19h-6.74a.63.63 0 0 0-.63.63v2.74c0 .348.282.63.63.63h6.74a.63.63 0 0 0 .63-.63v-2.74a.63.63 0 0 0-.63-.63M33.37 11h-6.74a.63.63 0 0 0-.63.63v2.74c0 .348.282.63.63.63h6.74a.63.63 0 0 0 .63-.63v-2.74a.63.63 0 0 0-.63-.63"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M10.62 14.368V10.92h1v3.453a2.22 2.22 0 0 1-2.207 2.207H8.5v4.5h-1v-5.5h1.908a1.22 1.22 0 0 0 1.212-1.212M27.5 18.62v4.63a4.5 4.5 0 0 1-4.5 4.5 4.44 4.44 0 0 1-2.613-.845l.587-.81a3.44 3.44 0 0 0 2.025.655H23a3.5 3.5 0 0 0 3.5-3.5v-4.63zM23 27.75v-.5l.001.5"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgLoodgieter);

export default ForwardRef;
